var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        lazy: "",
        "full-width": !_vm.$vuetify.breakpoint.smAndDown,
        "max-width": "500"
      },
      on: {
        input: function(v) {
          return v
        }
      },
      model: {
        value: _vm.openDialog,
        callback: function($$v) {
          _vm.openDialog = $$v
        },
        expression: "openDialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "pa-4" },
        [
          _c(
            "v-layout",
            { attrs: { column: "" } },
            [
              _c("v-text-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "`required`"
                  }
                ],
                attrs: {
                  "data-vv-as": "Nickname",
                  "data-vv-name": "nickname",
                  "data-vv-scope": "modal",
                  label: "Nickname"
                },
                model: {
                  value: _vm.nickname,
                  callback: function($$v) {
                    _vm.nickname = $$v
                  },
                  expression: "nickname"
                }
              }),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "accent",
                        loading: _vm.loadingBtn,
                        disabled: _vm.errors.any("modal")
                      },
                      on: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    },
                    [_vm._v("\n          Save\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "accent", flat: "" },
                      on: {
                        click: function($event) {
                          _vm.openDialog = false
                        }
                      }
                    },
                    [_vm._v("\n          Cancel\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54422ba0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54422ba0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditNicknameDialog.vue
// module id = null
// module chunks = 